export default "__VITE_PUBLIC_ASSET__28e47bea__"